module.exports = __webpack_public_path__ + "static/media/supportIcon.21be0aa2.png";